import React from "react";

import User from "../../components/pages/User";
import {
  deleteUser,
  getUsersList,
  updateUser,
  createUser,
  updateUserPassword,
} from "../../services/users";
import Notifications from "../../utils/notifications";

function Users() {
  const [userList, setUsersList] = React.useState([]);

  async function fetchUsers() {
    Notifications.activity("Fetching user information...");
    const { data, error } = await getUsersList();
    Notifications.clear();

    if (!error) {
      Notifications.success("User information successfully fetched!");
      setUsersList(data);
    } else {
      Notifications.error(data.message);
    }
  }

  async function updateUserInfo(userInfo) {
    const { username } = userInfo;
    const user = { ...userInfo };

    delete user.username;

    Notifications.activity("Updating user information...");

    const { data, error } = await updateUser(user, username);

    Notifications.clear();

    if (!error) {
      Notifications.success("User information successfully updated!");
      fetchUsers();
      return true;
    } else {
      Notifications.error(data.message);
      return false;
    }
  }

  async function deleteUserInfo(userInfo) {
    const { username } = userInfo;
    const user = { ...userInfo };

    delete user.username;
    delete user.active;
    delete user.grant_type;

    Notifications.activity("Deactivating user...");

    const { data, error } = await deleteUser(user, username);

    Notifications.clear();

    if (!error) {
      Notifications.success("User successfully deactivated!");
      fetchUsers();
    } else {
      Notifications.error(data.message);
    }
  }

  async function onUserCreate(userInfo) {
    Notifications.activity("Creating user...");

    const { data, error } = await createUser(userInfo);

    Notifications.clear();

    if (!error) {
      Notifications.success("User successfully created!");
      fetchUsers();
      return true;
    } else {
      Notifications.error(data.message);
      return false;
    }
  }

  async function updatePassword(body, params) {
    Notifications.activity("Updating user password...");

    const { data, error } = await updateUserPassword(body, params);

    Notifications.clear();

    if (!error) {
      Notifications.success("Password successfully updated!");
      //fetchUsers();
      return true;
    } else {
      Notifications.error(data.message);
      return false;
    }
  }

  React.useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <User
      userList={userList}
      updateUser={updateUserInfo}
      deleteUser={deleteUserInfo}
      onUserCreate={onUserCreate}
      updatePassword={updatePassword}
    />
  );
}

export default Users;
